import comp from "./LockingTimerComponent";
export default comp;
